import { render, staticRenderFns } from "./CRMLawcaseTableHead.vue?vue&type=template&id=734eb148&scoped=true&"
import script from "./CRMLawcaseTableHead.vue?vue&type=script&lang=js&"
export * from "./CRMLawcaseTableHead.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcaseTableHead.vue?vue&type=style&index=0&id=734eb148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734eb148",
  null
  
)

export default component.exports